import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { ModalRendererComponent } from '../../widgets/modal-renderer/modal-renderer.component';
import { SseService } from '../../../api/services/sse.service';

@Component({
    selector: 'app-domain-rows',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './domain-rows.component.html',
    styleUrl: './domain-rows.component.css'
})
export class DomainRowsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Output() handleTaskMappingDependency = new EventEmitter<{
    fieldName: string;
    tags: any[];
    selectedQuestion: any;
  }>();
  @ViewChild(ModalRendererComponent)
  ModalRendererComponent!: ModalRendererComponent;
  fieldsData: any;
  selectedItem: any = null;
  endpoint = environment.api_endpoint;
  intervalID: any;
  private lastTaskMappingSignature: string | null = null;
  constructor(
    private formService: FormsServiceService,
    private sseService: SseService,
  ) {}
  ngOnInit() {
    this.sseService.getMessages().subscribe((msg: any) => {
      const type = msg?.type;
      if (
        type === 'connectionSuccess' ||
        type === 200 ||
        type == 'connectSuccess' ||
        msg?.payload?.status == 200
      ) {
        this.getData();
      }
    });
    this.getData();
    this.intervalID = setInterval(() => {
      this.getData();
    }, 3000);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes['formGroup'] || changes['fields']) &&
      this.formGroup &&
      this.fields
    ) {
      this.lastTaskMappingSignature = null;
      this.getData();
    }
  }

  ngOnDestroy() {
    if (this.intervalID) {
      clearInterval(this.intervalID);
    }
  }

  /** Function to get the data by api or static */
  getData() {
    if (this.fields) {
      if (this.fields?.options?.isStatic == true) {
        this.fieldsData = this.fields?.options?.staticOptions;
        this.emitTaskMappingDependency(this.fieldsData || []);
      } else {
        const formId = this.fields.options.source.formID;
        const api_endpoint = this.endpoint;
        const method = this.fields.options.source.method;
        let url = this.fields.options.source.apiUrl;
        const replacements = {
          formID: formId,
          api_endpoint: api_endpoint,
        };
        url = this.formService.replaceTemplateTokens(url, replacements);
        const headers = {
          'Content-Type': 'application/json',
        };
        this.formService.loadData(method, url, headers).subscribe({
          next: (res: any) => {
            const records = res?.data?.records || [];
            this.fieldsData = records;
            this.emitTaskMappingDependency(records);
          },
          error: (err: any) => {
            console.error('Error fetching form data:', err);
          },
        });
      }
    }
  }

  onCheckboxChange(event: any, value: string) {
    const selected: string[] =
      this.formGroup.get(this.fields.fieldName)?.value || [];
    if (event.target.checked) {
      selected.push(value);
    } else {
      const index = selected.indexOf(value);
      if (index !== -1) {
        selected.splice(index, 1);
      }
    }
    this.formGroup.get(this.fields.fieldName)?.setValue(selected);
  }

  get isScanning(): boolean {
    return this.fieldsData?.some((item: any) => !item.DMARC);
  }

  formatEmailProvider(value: string): string {
    if (!value) return '';
    return value.length > 6
      ? `${value.slice(0, 6)}<br>${value.slice(6)}`
      : value;
  }

  private emitTaskMappingDependency(records: any[]) {
    const domains = records
      .map((record: any) => record?.domain)
      .filter(
        (domain: any) =>
          domain !== null && domain !== undefined && domain !== '',
      );
    const signature = domains.join('|');

    if (signature === this.lastTaskMappingSignature) {
      return;
    }

    this.lastTaskMappingSignature = signature;
    this.formGroup?.get(this.fields?.fieldName)?.setValue(domains, {
      emitEvent: false,
    });
    this.formGroup?.get(`${this.fields?.fieldName}Tags`)?.setValue(domains, {
      emitEvent: false,
    });

    this.handleTaskMappingDependency.emit({
      fieldName: this.fields?.fieldName,
      tags: ['Any domain added'],
      selectedQuestion: 'Add Domain',
    });
  }
}
